import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, inject } from '@angular/core';
import { ReducedScheduleTask } from 'src/app/models/scheduleTask.model';
import { UserService } from 'src/app/shared/services/user.service';
import { poolColors } from 'src/assets/data/pool-colors';
import { thirdPartyApp } from 'src/assets/data/third-party-app';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { NgClass, DatePipe } from '@angular/common';
import { MatCard, MatCardHeader, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-item-template',
    templateUrl: './item-template.component.html',
    styleUrls: ['./item-template.component.scss'],
    imports: [MatMenuTrigger, NgClass, MatMenu, MatCard, MatCardHeader, MatCardContent, MatCardActions, MatButton, DatePipe]
})
export class ItemTemplateComponent implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly el = inject(ElementRef);
  userSrv = inject(UserService);


  @Input() view: string = 'month';
  @Input() data: any;
  @Input() statusColor: any;
  @Input() statusSelectedColor: any;
  @Input() statusDescription: any;
  @Input() weekEvent: any;
  @Input() daysInWeek: any;
  @Input() events: any;
  @Input() event: any;
  @Input() eventClicked: any;
  @Input() height!: number;

  @Output() openDialogEvent = new EventEmitter<any>();

  poolColors: any[] = poolColors;
  thirdPartyAppList = thirdPartyApp;

  ngOnInit(): void {
    let test = this.data.isReadOnly;
  }

  dialogAction(): void {
    this.openDialogEvent.emit();
  }

  getPoolColor(color: string) {
    return this.poolColors.find((x) => x.name == color)?.code ?? '#fff';
  }

  getThirdPartyAppName(fromThirdPartyApp: number) {
    let thirdPartyAppName: any;
    thirdPartyAppName = this.thirdPartyAppList.find(
      (x) => x.id == fromThirdPartyApp
    )?.name;

    return thirdPartyAppName ? thirdPartyAppName : '';
  }

  applyPendingContactStyle(task: ReducedScheduleTask): boolean {
    if (this.userSrv.hasPermission('view:pendingContactFilter')) {
      return !task.hasClientContact;
    }
    return false;
  }
}
